/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `Parent Of` - PARENT_OF
 * * `Blocks` - BLOCKS
 * * `Relates To` - RELATES_TO
 * * `Duplicates` - DUPLICATES
 * * `Custom` - CUSTOM
 */
export enum RelationshipKindKind {
  PARENT_OF = 'Parent Of',
  BLOCKS = 'Blocks',
  RELATES_TO = 'Relates To',
  DUPLICATES = 'Duplicates',
  CUSTOM = 'Custom',
}
